import { useEffect, useRef } from "react";
import { useOptionalInternalWebRTC } from "@components/internal-contacts";
import { useOptionalVirtualAssistant } from "@components/virtual-receptionist/context/VirtualAssistantContext";
import { pauseAllAudioPlaybacks } from "./audioPlaybackRegistry";

export const AudioPlaybackCallGuard = () => {
  const internal = useOptionalInternalWebRTC();
  const voip = useOptionalVirtualAssistant();

  const hasWebrtcCall = !!internal && internal.phase !== "idle" && internal.phase !== "ended";

  const hasPstnCall =
    !!voip &&
    ((voip.incomingCalls?.length ?? 0) > 0 ||
      Array.from(voip.companiesState.values()).some((state) => Boolean(state.activeCall)));

  const hasCall = hasWebrtcCall || hasPstnCall;
  const hadCallRef = useRef(false);

  useEffect(() => {
    if (hasCall && !hadCallRef.current) {
      pauseAllAudioPlaybacks();
    }

    hadCallRef.current = hasCall;
  }, [hasCall]);

  return null;
};
